var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"user-page"}},[_c('Header'),_c('CompanyMyList')],1)}
var staticRenderFns = []

export { render, staticRenderFns }